import { Observable } from "rxjs";
import { Icon } from "./icon-model";

export interface IModalPMVModel {
  availableSpotNumber: number;
  category: string;
  occupiedSpotNumber: number;
  totalSpotNumber: number;
  name: string;
  title: string;
  maximumParkingDuration: string;
  icon: Icon
}

export interface IPanel {
  "imageOrder": 0;
  "iamgeBase64": string;
}


export abstract class AbstractPmvDataSource {
  abstract getPanelsById(id: string): Observable<IPanel[]>;
}
